import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSpellCheck = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.78947 5.68421C8.23112 5.68421 7.69564 5.90601 7.30083 6.30083C6.90601 6.69564 6.68421 7.23112 6.68421 7.78947V9.05262H10.8947V7.78947C10.8947 7.23112 10.6729 6.69564 10.2781 6.30083C9.88331 5.90601 9.34782 5.68421 8.78947 5.68421ZM5 7.78947V9.89472V14.1053C5 14.5703 5.37702 14.9474 5.84211 14.9474C6.30719 14.9474 6.68421 14.5703 6.68421 14.1053V10.7368H10.8947V14.1053C10.8947 14.5703 11.2718 14.9474 11.7368 14.9474C12.2019 14.9474 12.5789 14.5703 12.5789 14.1053V9.89472V7.78947C12.5789 6.78444 12.1797 5.82058 11.469 5.10991C10.7584 4.39925 9.7945 4 8.78947 4C7.78444 4 6.82058 4.39925 6.10991 5.10991C5.39925 5.82058 5 6.78444 5 7.78947ZM19.0691 13.8585C19.398 13.5297 19.398 12.9965 19.0691 12.6676C18.7402 12.3387 18.207 12.3387 17.8782 12.6676L12.5789 17.9669L10.648 16.036C10.3192 15.7072 9.78599 15.7072 9.45712 16.036C9.12826 16.3649 9.12826 16.8981 9.45712 17.2269L11.9834 19.7533C12.3123 20.0821 12.8455 20.0821 13.1744 19.7533L19.0691 13.8585Z"
        />
      </svg>
    );
  }
);
